import React,{useState}from "react";
import { useDimensions } from "../../Util";
import AddictionCard from "./AddictionCard";

const AddictionsContainer = ({ addictionsData }) => {

    const { w, h } = useDimensions();


    const addictionsContainer = {
        gridRow: w > h ? "1 / 51" : "1/20",
        gridColumn: w > h ? "1 / 12" : "1/30",
        overflowX: "hidden",
        overflowY: "scroll",
        scrollbarColor: "#00ADB5 #222831",
        scrollbarWidth: "thin",
        direction: "rtl",
        boxSizing: "border-box",
        width: "100%",
        height: "100%",
    };

    const addictionsContainerMob = {
        gridRow: w > h ? "1 / 51" : "1/20",
        gridColumn: w > h ? "1 / 12" : "1/30",
        overflowX: "hidden",
        overflowY: "scroll",
        scrollbarColor: "#00ADB5 #222831",
        scrollbarWidth: "thin",
        direction: "rtl",
        boxSizing: "border-box",
        width: "100%",
        height: "100%",
        display:"flex",
        flexDirection:"row",
        flexWrap:"wrap"
    };

    return <div id="addictions-container" style={w>h?addictionsContainer:addictionsContainerMob}>
        {addictionsData.map((card, index) => (
            <AddictionCard
                key={index}
                id={card.id}
                image={card.image}
                text={card.text}
                tagLine={card.tagLine}
                penalty={card.penalty}
                punishment={card.punishment}
                question={card.question}
                type={card.type}
            />
        ))}
    </div>
}

export default AddictionsContainer;